"use client";

import { useEffect, useRef } from "react";

import { useTranslations } from "next-intl";
import { toast } from "sonner";

import { useSwRegistration } from "@/hooks/use-sw-registration";

export function SwUpdateToast() {
  const t = useTranslations("Connectivity");
  const { hasUpdate, applyUpdate } = useSwRegistration();
  const toastIdRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (!hasUpdate) return;
    if (toastIdRef.current !== null) return;
    toastIdRef.current = toast(t("updateAvailable"), {
      duration: Infinity,
      action: {
        label: t("reload"),
        onClick: () => {
          applyUpdate();
        },
      },
    });
    return () => {
      if (toastIdRef.current !== null) {
        toast.dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    };
  }, [hasUpdate, applyUpdate, t]);

  return null;
}
